<template>
    <div class="socialevents">
        <h2 class="card-title">Club Events</h2>
        <p style="font-size: 20px; font-weight: 400;">Join our vibrant community events and competitions</p>
        <div class="buttons">
            <button v-for="(btn, index) in buttons" :key="index" @click="setActive(index)" :class="[
                'px-4 py-2 rounded-md transition',
                activeIndex === index
                    ? 'btn-active'
                    : 'btn-not-active'
            ]">
                {{ btn }}
            </button>
        </div>
        <div class="cards">
            <PlanCard v-for="(card, index) in dataList" :key="index" :title="card.title" :content="card.description"
                :start_date="card.start_date" :end_date="card.end_date" :time="formatTimeToAmPm(card.time)" :venue="card.venue" :users="card.capacity" :capacity_type="card.capacity_type" :type="card.category"
                :status="card.status" :event_status="card.event_status" 
                @cardClick="openEventDetails(card)"
                @registerClick="goToRegistration(card)"    
            />
        </div>
    </div>

    <!-- Tournament Registration Modal -->
<div
  class="modal fade"
  id="tournamentModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">Club Event Registration</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <!-- Registration Form -->
      <form id="tournamentForm">
        <div class="modal-body text-start">

          <!-- Tournament Type -->
          <div class="mb-3">
            <label class="form-label">Tournament Type</label>
            <select
              class="form-select"
              v-model="tournamentType"
              required
            >
              <option value="">Select tournament type</option>
              <option v-for="(data, index) in typeList" :key="index" :value="data.tournament_type">{{ data.tournament_type}}</option>
            </select>
          </div>

          <!-- Junior Category (Conditional) -->
          <div
            class="mb-3"
            v-if="tournamentType === 'junior'"
          >
            <label class="form-label">Junior Category</label>
            <select
              class="form-select"
              v-model="junior_category"
              required
            >
              <option value="">Select age group</option>
              <option value="u10">Under 10</option>
              <option value="u12">Under 12</option>
              <option value="u14">Under 14</option>
              <option value="u16">Under 16</option>
              <option value="u18">Under 18</option>
            </select>
          </div>

          <div
            class="mb-3"
            v-if="tournamentType === 'junior'"
          >
            <label class="form-label">Participant</label>
            <input type="text" v-model="participant" class="form-control" name="" id="" placeholder="Enter partipant name">
          </div>

          <!-- Team Category -->
          <div class="mb-3">
            <label class="form-label">Team Category</label>
            <select
              class="form-select"
              v-model="team"
              required
            >
              <option value="">Select team</option>
              <option v-for="(data, index) in teamList" :key="index" :value="data.team_name">{{ data.team_name}}</option>
            </select>
          </div>

          <!-- Payment Notice -->
          <div class="alert alert-info mb-0">
            {{ registration_info }}
          </div>

        </div>

        <!-- Modal Footer -->
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>

          <!-- Paystack Trigger -->
          <button
            type="button"
            class="btn btn-success"
            @click="payWithPaystack()"
          >
            {{ continue_registration }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

</template>

<script setup>
    /* eslint-disable */
    import PlanCard from './CommonCard/PlanCard.vue';
    import { ref, onMounted,computed, onBeforeUnmount } from "vue";
    import axios from 'axios';
    import router from "@/router";
    import { Modal } from 'bootstrap';
    import PaystackPop from '@paystack/inline-js';

    const buttons = ["All", "Adult", "Junior", "Leagues", "Social"];
    const activeIndex = ref(0);
    const loggedId = ref(localStorage.getItem('userid'));
    const tournamentType = ref('');
    const junior_category = ref('')
    const participant = ref('')
    const team = ref('')
    const email_address = ref(localStorage.getItem('email_address'));
    const event_fees = ref([])
    const event_status = ref([])
    const typeList = ref([])
    const teamList = ref([])

    const setActive = (index) => {
        activeIndex.value = index;
    };
    
    let base_url = process.env.VUE_APP_BASE_LIVE_URL
    const dataList = ref([]);
    const continue_registration = ref('')
    const registration_info = ref('')

    onBeforeUnmount( async () => {
      
    });
    
    onMounted(async () => {
        await listRecords()
        await listTypes()
        await listTeams()
    });
  
    const listRecords = async () => {
      try {
        const response = await axios.get('/list_events.php', { });
        if (response.data.status) dataList.value = response.data.data;
        else console.error(response.data.message);
      } catch (error) {
        console.error(error.message);
      }
    };

    const goToRegistration = (card) => {
    // 1. Check if registration is open
    if (card.status !== 'open') {
        alert('Registration for this event is currently closed.');
        return;
    }

    //alert(JSON.stringify(card))

    // 2. Capacity validation (MAX SLOT CHECK)
    if (card.capacity && card.registered_count >= card.capacity) {
        alert('This event is already full. No more slots available.');
        return;
    }

    // 3. Event type (free / paid)
    if (card.event_status === 'free') {
        registration_info.value = "This event does not require payment to complete registration.";
        continue_registration.value = "Submit";
    } else if (card.event_status === 'paid') {
        registration_info.value = "Payment is required to complete this registration";
        continue_registration.value = "Proceed to Payment";
    }

    // 4. If user not logged in
    if (!loggedId.value) {
        router.push('/login/registerEvent');
        return;
    }

    event_fees.value = card;
    event_status.value = card;

    // 5. Open registration modal
    const modal = new Modal(document.getElementById('tournamentModal'));
    modal.show();
    };

    const formatDate = (dateString) => {
    const date = new Date(dateString);

    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

    return {
            month: months[date.getMonth()],
            dayNumber: String(date.getDate()).padStart(2, "0"),
            dayText: days[date.getDay()]
        };
    }

  const formatTimeToAmPm = (time) => {
    if (!time) return "";

    const [hours, minutes] = time.split(":");
    let h = parseInt(hours, 10);
    const ampm = h >= 12 ? "PM" : "AM";

    h = h % 12 || 12; // convert 0 → 12

    return `${h}:${minutes}${ampm}`;
  }

  const payWithPaystack = () => {
    //console.log(event_fees.value)
    if (!tournamentType.value) {
    alert('Please select a tournament type.');
    return;
    }

    if (tournamentType.value === 'junior' && !junior_category.value) {
    alert('Please select a junior category.');
    return;
    }

    if (!team.value) {
    alert('Please select a team.');
    return;
    }

    if (!email_address.value) {
        alert('Your email address is missing. Please update your email address.');
        return;
    }

    if (event_status.value.event_status === 'paid') {
      const paystack = new PaystackPop();

      paystack.newTransaction({
          key: process.env.VUE_APP_PAYSTACK_LIVE_KEY,
          email: email_address.value,
          amount: Number(event_fees.value.program_fee) * 100,

          onSuccess: (transaction) => { 
              // Payment complete! Reference: transaction.reference 
              const payment_ref = transaction.reference 
              createPayment(event_fees.value, payment_ref, event_status.value.event_status, tournamentType.value, junior_category.value, team.value)
          },
          onCancel: () => {
              // user closed popup
          }
      });
    }

    createPayment(event_fees.value, 'payment_ref', event_status.value.event_status, tournamentType.value, junior_category.value, team.value)
    
  }

  const createPayment = async (data, reference, event_status, tournament, junior, teams) => {
    try {
      const response = await axios.post('/event_payment.php', { user_id: loggedId.value, event_id: data.id, amount: data.program_fee, email: email_address.value, description: reference, event_status: event_status, payment_status: 'event-booking', tournament_type: tournament, junior_category: junior, participant: participant.value, teams: teams });
      if (response.data.status) {
        alert(response.data.message) 
        window.location.reload();
      }
      else console.error(response.data.message);
    } catch (error) {
      const message = error.response?.data?.message || "";

      // MySQL duplicate entry error (unique constraint)
      if (message.includes("Duplicate entry") && message.includes("uq_event_user")) {
        alert("You have already registered for this event.");
        return;
      }

      // fallback for other errors
      alert("Something went wrong. Please try again.");
      console.error("Error:", error.response ? error.response.data : error.message);
    }

  };

  const listTypes = async () => {
  try {
    const response = await axios.get('/club_event_tournament_list.php', { });
    if (response.data.status) typeList.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listTeams = async () => {
  try {
    const response = await axios.get('/club_event_team_list.php', { });
    if (response.data.status) teamList.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

</script>

<style scoped lang="scss">
.socialevents {
    max-width: 80%;
    margin: auto;
    margin-top: 5rem;
}

.btn-active {
    background-color: #ED4E24;
    color: #fff;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    border: 2px solid #ED4E24;
    border-radius: 60px;
    width: 103px;
}

.btn-not-active {
    background-color: #fff;
    border: 2px solid #9B9A9A;
    color: #9B9A9A;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    border-radius: 60px;
    width: 103px;

}

.buttons {
    display: flex;
    gap: 20px;
    justify-content: center;
    align-items: center;
    overflow-x: auto;
    padding: 0 0 0 15px;
}

.cards {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-top: 5rem;
}
.card-title{
    font-size: 48px; 
    font-weight: 400;
}
@media (max-width: 768px) {
    .socialevents {
        max-width: 100%;
        margin: auto;
        margin-top: 2rem;
    }

    .cards {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 20px;
        margin-top: 5rem;
    }
    .card-title{
        font-size: 35px; 
    }
}
</style>
